export interface stateConfig {
  name: string;
  displayName?: string;
  position: point;
}

export interface transitionConfig {
  name: string;
  startState: string;
  endStateOne: IremboEndState | undefined;
  endStateTwo: IremboEndState | undefined;
  authorisation?: IremboAuthorisation;
  position: point;
}

export interface point {
  x: number;
  y: number;
}

export interface Workflow {
  states: Map<string, stateConfig>;
  transitions: transitionConfig[];
}

export interface IremboAuthorisation {
  authorisedRoles: string[];
  authorisedUsers: string[];
  systemAuthorised: boolean;
}

export interface IremboTransition {
  event: string;
  startState: string;
  endStateOne?: IremboEndState | undefined;
  endStateTwo?: IremboEndState | undefined;
  authorisation?: IremboAuthorisation;
  position?: point;
}

export interface IremboEndState {
  nextEvent: string | undefined;
  stateCode: string;
  stateName: string;
  breakingAction?: IremboAction | undefined;
  nonBreakingActionList?: IremboAction[] | undefined;
  position?: point | undefined;
}

export interface IremboAction {
  args: any;
  actionType: string;
}

export enum IremboEvent {
  CREATE,
  PAY,
  PUSH,
}

export enum IremboState {
  NEW,
  PAYMENT_PENDING,
  PAID,
  SUBMITTED,
}

export enum IremboActionType {
  NOTIFICATION,
  BILL_ID_GENERATION,
}

export const FINAL_APPROVAL_STATES = [
  'APPROVED',
  'PUSHED_TO_PARTNER',
  'PUSHED_TO_PARTNER',
];
export const FINAL_REJECTION_STATES = ['REJECTED', 'PAYMENT_EXPIRED'];
